import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';

import { TabViewModule } from 'primeng/tabview';

import { HisSharedModule, HisSummernoteSharedModule } from 'hisng';

import { CommonSharedModule } from '../common/common-shared.module';

import { PersonSearchFormComponent } from './component/person/person-search-form.component';
import { PersonSearchResultComponent } from './component/person/person-search-result.component';
import { PersonDetailViewComponent } from './component/person/person-detail-view.component';
import { PersonDetailViewVCardComponent } from './component/person/vcard/person-detail-view-vcard.component';
import { PersonDetailViewContactDataComponent } from './component/person/vcard/person-detail-view-contactdata.component';
import { PersonDetailViewAddressesComponent } from './component/person/vcard/person-detail-view-addresses.component';
import { UnitSearchResultComponent } from './component/person/unit-search-result.component';
import { UnitSearchFormComponent } from './component/person/unit-search-form.component';
import { PanelModule } from 'primeng/panel';
import { PersonIdAssignmentFormComponent } from './component/idAssignment/person-id-assignment-form.component';
import { PersonIdAssignmentSearchFormComponent } from './component/idAssignment/person-id-assignment-search-form.component';
import { PersonIdAssignmentSearchResultComponent } from './component/idAssignment/person-id-assignment-search-result.component';
import { ProgressBarModule } from 'primeng/progressbar';
import { PersonDetailViewSearchResultComponent } from './component/person/person-detail-view-search-result.component';
import { PaginatorModule } from 'primeng/paginator';
import { PersonProfileEditFormComponent } from './component/profile/personprofile-edit-form.component';
import { PersonProfileEntryEditBasicDataComponent } from './component/profile/edit/personprofile-edit-basic-data.component';
import { PersonProfileEditClassificationsComponent } from './component/profile/edit/personprofile-edit-classifications.component';
import { PersonProfileEditEmploymentClassificationsComponent } from './component/profile/edit/personprofile-edit-employment-classifications.component';

/**
 * SharedModule for persons.
 */
@NgModule( {
    imports: [
        CommonModule,
        RouterModule,
        FormsModule,
        ReactiveFormsModule,

        // primeng
        TabViewModule,
        ProgressBarModule,
        PaginatorModule,

        // HIS
        HisSharedModule,
        CommonSharedModule,
        PanelModule,
        HisSummernoteSharedModule,
    ],

    declarations: [
        PersonSearchFormComponent,
        PersonSearchResultComponent,
        PersonDetailViewComponent,
        PersonDetailViewVCardComponent,
        PersonDetailViewContactDataComponent,
        PersonDetailViewAddressesComponent,
        UnitSearchResultComponent,
        UnitSearchFormComponent,
        PersonIdAssignmentFormComponent,
        PersonIdAssignmentSearchFormComponent,
        PersonIdAssignmentSearchResultComponent,
        PersonDetailViewSearchResultComponent,
        PersonProfileEditFormComponent,
        PersonProfileEntryEditBasicDataComponent,
        PersonProfileEditClassificationsComponent,
        PersonProfileEditEmploymentClassificationsComponent

    ],

    exports: []

    // NO PROVIDERS! Providers need to go into PersonCoreModule
} )
export class PersonSharedModule {
}
